var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_100, BLUE_500, Card, checkIsPlatform, Divider, DynamicSvg, getTestId, GradientView, InfoTag, isLastItem, isValidObject, KeyPairUnit, LILAC_200, LILAC_600, StateConfigContext, Typography, useBreakpoint, WHITE } from '@airtel/air-design-system';
import { useContext } from 'react';
import { Pressable, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { CarouselWidget } from '../carousel-widget';
import { PackInfo } from './components';
import { AdditionalBenefitsCard } from './components/additional-benefits-card/AdditionalBenefitsCard';
import { getPackCardWidgetStyles } from './PackCardWidgetStyles';
export var PackCardWidgetComponent = props => {
  var _a, _b, _c;
  var packCardWidgetStyles = getPackCardWidgetStyles(props);
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var id = props.id,
    title = props.title,
    _props$headingNumberO = props.headingNumberOfLines,
    headingNumberOfLines = _props$headingNumberO === void 0 ? 1 : _props$headingNumberO,
    _props$bannerNumberOf = props.bannerNumberOfLines,
    bannerNumberOfLines = _props$bannerNumberOf === void 0 ? 1 : _props$bannerNumberOf,
    heading = props.heading,
    _props$planInfo = props.planInfo,
    planInfo = _props$planInfo === void 0 ? [] : _props$planInfo,
    keyPairUnitData = props.keyPairUnitData,
    _props$additionalBene = props.additionalBenefits,
    additionalBenefits = _props$additionalBene === void 0 ? [] : _props$additionalBene,
    _props$offerBannerTex = props.offerBannerText,
    offerBannerText = _props$offerBannerTex === void 0 ? [] : _props$offerBannerTex,
    _props$offerBannerIco = props.offerBannerIcon,
    offerBannerIcon = _props$offerBannerIco === void 0 ? 'OfferButtonIcon' : _props$offerBannerIco,
    _props$offerBannerIco2 = props.offerBannerIconProps,
    offerBannerIconProps = _props$offerBannerIco2 === void 0 ? {
      fontSize: 20
    } : _props$offerBannerIco2,
    onCardPress = props.onCardPress,
    onCardPressHandler = props.onCardPressHandler,
    onLeftCtaPress = props.onLeftCtaPress,
    onRightCtaPress = props.onRightCtaPress,
    _onUserAction = props.onUserAction,
    _props$infoTagArray = props.infoTagArray,
    infoTagArray = _props$infoTagArray === void 0 ? [] : _props$infoTagArray,
    hideDivider = props.hideDivider,
    carouselData = props.carouselData,
    _props$buttonWidgetDa = props.buttonWidgetData,
    buttonWidgetData = _props$buttonWidgetDa === void 0 ? {} : _props$buttonWidgetDa,
    _props$priceDetails = props.priceDetails,
    priceDetails = _props$priceDetails === void 0 ? {} : _props$priceDetails,
    cardStyle = props.cardStyle,
    _props$noCardPadding = props.noCardPadding,
    noCardPadding = _props$noCardPadding === void 0 ? false : _props$noCardPadding,
    _props$showEmptyBox = props.showEmptyBox,
    showEmptyBox = _props$showEmptyBox === void 0 ? false : _props$showEmptyBox,
    _props$withRoundedBor = props.withRoundedBorder,
    withRoundedBorder = _props$withRoundedBor === void 0 ? true : _props$withRoundedBor,
    _props$numOfLinesInTi = props.numOfLinesInTitle,
    numOfLinesInTitle = _props$numOfLinesInTi === void 0 ? 1 : _props$numOfLinesInTi,
    _props$showPackSelect = props.showPackSelection,
    _showPackSelection = _props$showPackSelect === void 0 ? false : _props$showPackSelect,
    _props$cardBorderColo = props.cardBorderColor,
    cardBorderColor = _props$cardBorderColo === void 0 ? theme == 'white' ? 'transparent' : LILAC_600 : _props$cardBorderColo,
    isSelected = props.isSelected,
    additionalBenefitContainerStyle = props.additionalBenefitContainerStyle,
    style = props.style,
    _props$packCardBackgr = props.packCardBackgroundColor,
    packCardBackgroundColor = _props$packCardBackgr === void 0 ? theme == 'white' ? 'transparent' : LILAC_200 : _props$packCardBackgr,
    accessibilityProps = props.accessibilityProps,
    _props$showAdditional = props.showAdditionalBenefits,
    showAdditionalBenefits = _props$showAdditional === void 0 ? false : _props$showAdditional,
    _props$showEmptyInfoT = props.showEmptyInfoTagContainer,
    _showEmptyInfoTagContainer = _props$showEmptyInfoT === void 0 ? false : _props$showEmptyInfoT,
    _props$showEmptyInfoT2 = props.showEmptyInfoTagContainerMobile,
    showEmptyInfoTagContainerMobile = _props$showEmptyInfoT2 === void 0 ? true : _props$showEmptyInfoT2,
    restProps = __rest(props, ["id", "title", "headingNumberOfLines", "bannerNumberOfLines", "heading", "planInfo", "keyPairUnitData", "additionalBenefits", "offerBannerText", "offerBannerIcon", "offerBannerIconProps", "onCardPress", "onCardPressHandler", "onLeftCtaPress", "onRightCtaPress", "onUserAction", "infoTagArray", "hideDivider", "carouselData", "buttonWidgetData", "priceDetails", "cardStyle", "noCardPadding", "showEmptyBox", "withRoundedBorder", "numOfLinesInTitle", "showPackSelection", "cardBorderColor", "isSelected", "additionalBenefitContainerStyle", "style", "packCardBackgroundColor", "accessibilityProps", "showAdditionalBenefits", "showEmptyInfoTagContainer", "showEmptyInfoTagContainerMobile"]);
  var _restProps$testID = restProps.testID,
    testID = _restProps$testID === void 0 ? 'PackCardWidget' : _restProps$testID;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var titleType = isSmallScreen ? 'body-para-md' : 'body-para-lg';
  var headingType = isSmallScreen ? 'body-single-line-md-bold' : 'body-single-line-lg-bold';
  var showBenefitSection = additionalBenefits && additionalBenefits.length > 0 || showAdditionalBenefits && !isSmallScreen;
  var actionButtonsSize = isSmallScreen ? 'sm' : 'md';
  var infoTagSize = isSmallScreen ? 'sm' : 'md';
  if ((_a = buttonWidgetData === null || buttonWidgetData === void 0 ? void 0 : buttonWidgetData.leftCta) === null || _a === void 0 ? void 0 : _a.size) {
    buttonWidgetData.leftCta.size = actionButtonsSize;
  }
  if ((_b = buttonWidgetData === null || buttonWidgetData === void 0 ? void 0 : buttonWidgetData.rightCta) === null || _b === void 0 ? void 0 : _b.size) {
    buttonWidgetData.rightCta.size = actionButtonsSize;
  }
  var showButtonWidget = buttonWidgetData && Object.keys(buttonWidgetData).length > 0;
  var selectionProps = {};
  if (isSelected) {
    selectionProps = {
      isSelected: true,
      buttonType: 'primary',
      title: 'Selected',
      iconName: 'TickButtonIcon'
    };
  } else {
    selectionProps = {
      isSelected: false,
      buttonType: 'secondary',
      title: 'Select'
    };
  }
  var infoTagDimensions = isSmallScreen ? {
    height: 28
  } : {
    height: 32
  };
  var showPackSelection = _showPackSelection && isSelected;
  var showEmptyInfoTagContainer = _showEmptyInfoTagContainer;
  if (_showEmptyInfoTagContainer && isSmallScreen) {
    showEmptyInfoTagContainer = showEmptyInfoTagContainerMobile;
  }
  return _jsx(_Fragment, {
    children: showEmptyBox ? _jsx(View, Object.assign({}, getTestId(testID), {
      style: style
    })) : _jsxs(View, Object.assign({}, getTestId(testID), {
      style: [packCardWidgetStyles.container, style]
    }, restProps, {
      children: [!!carouselData && _jsx(CarouselWidget, Object.assign({}, carouselData)), _jsxs(Pressable, Object.assign({}, getTestId(testID, 'press'), {
        onPress: event => {
          if (isValidObject(onCardPress)) {
            _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
              id
            }, onCardPress), {
              item: props
            });
            onCardPressHandler === null || onCardPressHandler === void 0 ? void 0 : onCardPressHandler(event);
          }
        }
      }, checkIsPlatform('web') && {
        tabIndex: 1
      }, accessibilityProps, {
        children: [_jsxs(Card, Object.assign({
          style: [packCardWidgetStyles.card, cardStyle],
          showShadow: false,
          noPadding: noCardPadding,
          withRoundedBorder: withRoundedBorder,
          borderColor: showPackSelection ? BLUE_500 : cardBorderColor,
          backgroundColor: packCardBackgroundColor
        }, {
          children: [(infoTagArray === null || infoTagArray === void 0 ? void 0 : infoTagArray.length) > 0 ? _jsx(View, Object.assign({
            style: packCardWidgetStyles.infoTagContainer
          }, getTestId(testID, 'infoTagWrapper'), {
            children: infoTagArray === null || infoTagArray === void 0 ? void 0 : infoTagArray.map((infoTag, index) => {
              return _jsx(InfoTag, Object.assign({
                type: "inline",
                size: infoTagSize,
                style: [packCardWidgetStyles.infoTag, isLastItem(infoTagArray, index) && {
                  marginRight: 0
                }]
              }, getTestId(testID, 'infoTag'), infoTag), "infoTag-" + index);
            })
          }), "infotag-text-" + id) : showEmptyInfoTagContainer && _jsx(View, Object.assign({
            style: [packCardWidgetStyles.infoTagContainer, infoTagDimensions]
          }, getTestId(testID, 'infoTagWrapper')), "infotag-text-" + id), !!heading && _jsx(Typography, Object.assign({
            numberOfLines: headingNumberOfLines,
            type: headingType,
            text: heading,
            style: packCardWidgetStyles === null || packCardWidgetStyles === void 0 ? void 0 : packCardWidgetStyles.headingContainer
          }, getTestId(testID, 'heading'))), !!title && _jsx(Typography, Object.assign({
            numberOfLines: numOfLinesInTitle,
            type: titleType,
            text: title,
            style: packCardWidgetStyles === null || packCardWidgetStyles === void 0 ? void 0 : packCardWidgetStyles.titleContainer
          }, getTestId(testID, 'title'))), !!((planInfo === null || planInfo === void 0 ? void 0 : planInfo.length) > 0 || isValidObject(priceDetails)) && _jsx(PackInfo, Object.assign({}, props, getTestId(testID, 'PackInfo'))), !!(((_c = keyPairUnitData === null || keyPairUnitData === void 0 ? void 0 : keyPairUnitData.data) === null || _c === void 0 ? void 0 : _c.length) > 0) && _jsx(KeyPairUnit, Object.assign({}, keyPairUnitData, getTestId(testID, 'keyPairInfo'))), showBenefitSection && (planInfo === null || planInfo === void 0 ? void 0 : planInfo.length) > 0 && !hideDivider && _jsx(Divider, {
            color: LILAC_600,
            height: 1
          }), showBenefitSection && _jsx(AdditionalBenefitsCard, Object.assign({
            additionalBenefitContainerStyle: additionalBenefitContainerStyle
          }, props, getTestId(testID, 'AdditionalBenefitsCard'))), showButtonWidget && _jsx(ButtonWidget, Object.assign({}, Object.assign(Object.assign({
            onRightCtaPress: onRightCtaPress,
            onLeftCtaPress: onLeftCtaPress
          }, buttonWidgetData), {
            testID: testID,
            rightCta: Object.assign(Object.assign({}, buttonWidgetData.rightCta), showPackSelection && selectionProps),
            leftCta: Object.assign({}, buttonWidgetData.leftCta)
          }), {
            onUserAction: (_a, _b) => {
              var id = _a.id,
                onLeftCtaPress = __rest(_a, ["id"]);
              var leftCta = _b.leftCta,
                restLeftCTA = __rest(_b, ["leftCta"]);
              onLeftCtaPress && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
                id
              }, onLeftCtaPress), Object.assign(Object.assign({
                leftCta
              }, restLeftCTA), {
                moreInfo: {
                  priceDetails,
                  title
                }
              })));
            }
          }))]
        })), (offerBannerText === null || offerBannerText === void 0 ? void 0 : offerBannerText.length) > 0 && _jsxs(GradientView, Object.assign({
          style: packCardWidgetStyles.offerBannerContainer
        }, {
          children: [!!offerBannerIcon && _jsx(DynamicSvg, Object.assign({
            iconName: offerBannerIcon,
            color: WHITE
          }, offerBannerIconProps)), _jsx(View, Object.assign({
            style: packCardWidgetStyles.offerBannerTextContainer
          }, {
            children: offerBannerText === null || offerBannerText === void 0 ? void 0 : offerBannerText.slice(0, 2).map((item, id) => _jsx(Typography, Object.assign({
              numberOfLines: bannerNumberOfLines,
              type: "body-single-line-xs-bold",
              text: item,
              color: BLACK_100,
              style: packCardWidgetStyles.offerBannerTextStyle
            }, getTestId(testID, 'offerBannerTextContainer')), "offer_banner_text_" + id))
          }))]
        }))]
      }))]
    }))
  });
};
PackCardWidgetComponent.genericRendererKey = 'AirPackCardWidget';